var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KLogo',{attrs:{"altText":"Kolibri logo with rectangular background and maxSize 30","size":35,"maxSize":30,"showBackground":true,"backgroundStyle":"rect"}})
}
var staticRenderFns = []

export { render, staticRenderFns }